module.exports = __webpack_public_path__ + "static/media/branding-img6.d4fe42be.jpg";